import { gql } from '@apollo/client'

export const Query = gql`
    query AddEvent($guid: String!) {
        entity(guid: $guid) {
            ... on Entity {
                guid
            }

            ... on Event {
                startDate
            }
        }
    }
`
